/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {GenericObject} from '@ion/core/src/types/entities';
import {UserPromptTypes} from '../../components/prompts/constants';
import {TOGGLE_USER_PROMPT} from '../actions/user-prompt';

// defines the shape of this reducers state ...
export type NotificationState = {
  display: boolean;
  text: string;
  translateOption?: GenericObject;
  translateText?: boolean;
  type: UserPromptTypes;
  actionLabel: string;
  autoHide: boolean;
  customDismissLabel: string;
  onDismiss?: () => void;
  onAction: () => void,
  autoHideDuration: number;
  partialSuccessState?: string | null;
  maxWidth?: string;
  displayOnlyInLayout?: boolean;
}

export interface UserPromptState {
  notification: NotificationState;
}

// defines the initial state for the reducer ...
export const initialState: UserPromptState = {
  notification : {
    display             : false,
    text                : '',
    type                : UserPromptTypes.Error,
    actionLabel         : '',
    autoHide            : true,
    customDismissLabel  : '',
    onDismiss           : null,
    onAction            : null,
    autoHideDuration    : 4000,
    translateOption     : {},
    translateText       : true,
    partialSuccessState : null,
    maxWidth            : null,
    displayOnlyInLayout : false
  }
};

// defines the reducers ...
const reducers = {

  [TOGGLE_USER_PROMPT] : ({notification}: UserPromptState, {options}) => {
    notification.display = options.display ?? !notification.display;
    notification.text = options?.message || '';
    notification.type = options?.type || null;
    notification.actionLabel = options?.actionLabel;
    notification.autoHide = options?.autoHide !== false;
    notification.customDismissLabel = options?.customDismissLabel || '';
    notification.onDismiss = options?.onDismiss || null;
    notification.onAction = options?.onAction || null;
    notification.autoHideDuration = options?.autoHideDuration ?? 4000;
    notification.translateOption = options?.translateOption || {};
    notification.translateText = options?.translateText;
    notification.partialSuccessState = options?.partialSuccessState || null;
    notification.maxWidth = options?.maxWidth || null;
    notification.displayOnlyInLayout = options?.displayOnlyInLayout ?? false;
  }

};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: UserPromptState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
